module.exports = __webpack_public_path__ + "static/54-VR-april2032-8c7074488629153bd25ca66ca49d4146.jpg";